import script from "./LeftBar1.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftBar1.vue?vue&type=script&setup=true&lang=js"

export default script